const RedeemRewardModal = ({
	isRedeemable,
	onClose = () => {},
	onConfirm,
	isLoading,
}) => {
	return (
		<div
			style={{
				position: 'fixed',
				width: '100%',
				top: 0,
				left: -32.5, //* No idea why
				padding: '0 32px',
				height: '100%',
				backgroundColor: 'rgba(0, 0, 0, 0.75)',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: 10000,
			}}
		>
			<div
				style={{
					margin: '0 20px',
					background: 'white',
					padding: '20px',
					borderRadius: '10px',
					maxWidth: '400px',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						gap: '16px',
					}}
				>
					<p
						style={{ fontWeight: 'bold', color: '#30e700' }}
						className="font-bold text-xl text-[#00257a]"
					>
						Redeem Reward?
					</p>
					<p style={{ fontSize: '14px', textAlign: 'center' }}>
						Are you sure you want to redeem this reward? Your points will be
						deducted once details confirmation are done.
					</p>
					<p style={{ fontSize: '14px', textAlign: 'center', color: 'red' }}>
						{isRedeemable
							? '**Once redeemed, items and e-vouchers cannot be canceled, returned, or exchanged for points.'
							: "You don't have enough points to redeem this reward."}
					</p>
					<div style={{ display: 'flex', gap: '8px', width: '100%' }}>
						<button
							style={{
								cursor: `${!isRedeemable ? 'not-allowed' : 'pointer'}`,
								padding: '8px 16px',
								width: '100%',
								borderRadius: '16px',
								outline: 'none',
								border: 'none',
								backgroundColor: `${isRedeemable ? '#30e700' : '#C4C4C4'}`,
								color: 'black',
								fontWeight: 'bold',
							}}
							className="fontSize-16 text-center font-family-hero-new"
							disabled={!isRedeemable || isLoading}
							onClick={async () => await onConfirm()}
						>
							{isLoading ? 'Submitting...' : 'Confirm'}
						</button>
						<button
							style={{
								cursor: 'pointer',
								padding: '8px 16px',
								width: '100%',
								borderRadius: '16px',
								outline: 'none',
								border: '1px solid #30e700',
								backgroundColor: 'white',
								color: '#30e700',
								fontWeight: 'bold',
							}}
							className="fontSize-16 text-center font-family-hero-new"
							onClick={onClose}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RedeemRewardModal;
